import { render, staticRenderFns } from "./MilestoneStep2.vue?vue&type=template&id=183485d4&scoped=true&"
import script from "./MilestoneStep2.vue?vue&type=script&lang=js&"
export * from "./MilestoneStep2.vue?vue&type=script&lang=js&"
import style0 from "./MilestoneStep2.vue?vue&type=style&index=0&id=183485d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183485d4",
  null
  
)

export default component.exports